import { isEmpty as i } from "@hprofits/utils/fp/optional";
import { z as e } from "zod";
import { WeekScheduleSchema as c, DictContentTypeOutputSchema as d, DictCategorySchema as y, KeywordsSchema as g, IPSelectorSchema as D, DictOSTypeOutputSchema as T, DictDeviceSchema as b, DictBrowserSchema as O, DimensionLanguageOutputSchema as I, DictGeoOutputSchema as j, SpotIdSchema as w, DomainNameSchema as R, ContentTypeNameSchema as q, DictCategoryIdSchema as C, DictOSTypeInputSchema as v, DictDeviceIdSchema as f, DictBrowserIdSchema as k, DictLanguageCodeSchema as L, DictGeoInputSchema as G } from "../schemas.js";
const x = e.enum(["include", "exclude"]), o = (s) => e.object({
  type: x,
  values: s.array().min(1)
}).readonly(), p = o(R), u = o(w), A = o(G), B = o(j), E = o(L), _ = o(I), K = o(k), N = o(O), P = o(f), U = o(b), z = o(T), H = o(v), m = o(D), r = o(g), M = o(C), W = o(y), X = o(q), F = o(d), S = e.object({
  schedule: c.optional(),
  domains: p.optional(),
  spots: u.optional(),
  geo: B.optional(),
  languages: _.optional(),
  browsers: N.optional(),
  devices: U.optional(),
  os: z.optional(),
  ips: m.optional(),
  keywords: r.optional(),
  categories: W.optional(),
  contentTypes: F.optional()
}).readonly(), J = e.object({
  schedule: c.optional(),
  domains: p.optional(),
  spots: u.optional(),
  geo: A.optional(),
  languages: E.optional(),
  browsers: K.optional(),
  devices: P.optional(),
  os: H.optional(),
  ips: m.optional(),
  keywords: r.optional(),
  categories: M.optional(),
  contentTypes: X.optional()
}).readonly(), Q = 20, V = e.string().trim().min(1).max(Q), Y = o(V), ve = S.unwrap().extend({ spots: Y.optional() }).readonly(), t = J.unwrap(), Z = e.keyof(t), fe = e.enum([...Z.options, "other", "time"]), $ = e.object({ schedule: t.shape.schedule }).required().readonly(), ee = e.object({ domains: t.shape.domains }).required().readonly(), oe = e.object({ spots: t.shape.spots }).required().readonly(), te = e.object({ geo: t.shape.geo }).required().readonly(), ne = e.object({ languages: t.shape.languages }).required().readonly(), se = e.object({ browsers: t.shape.browsers }).required().readonly(), ie = e.object({ devices: t.shape.devices }).required().readonly(), ae = e.object({ os: t.shape.os }).required().readonly(), ce = e.object({ ips: t.shape.ips }).required().readonly(), pe = e.object({ keywords: t.shape.keywords }).required().readonly(), ue = e.object({ contentTypes: t.shape.contentTypes }).required().readonly(), me = e.object({ categories: t.shape.categories }).required().readonly(), re = e.object({
  start: e.iso.datetime().optional(),
  end: e.iso.datetime().optional()
}), l = e.object({
  time: re
}).superRefine((s, a) => {
  i(s.time.start) && i(s.time.end) && a.addIssue("start or end time must be defined"), !i(s.time.start) && !i(s.time.end) && s.time.end < s.time.start && a.addIssue("end must be on or after start");
}).required().readonly(), h = e.literal("other").readonly(), ke = e.xor([
  $,
  ee,
  oe,
  te,
  ne,
  se,
  ie,
  ae,
  ce,
  pe,
  me,
  ue,
  l,
  h
]), n = S.unwrap(), Se = e.object({ schedule: n.shape.schedule }).required(), le = e.object({ geo: n.shape.geo }).required(), he = e.object({ domains: n.shape.domains }).required(), de = e.object({ spots: n.shape.spots }).required(), ye = e.object({ languages: n.shape.languages }).required(), ge = e.object({ browsers: n.shape.browsers }).required(), De = e.object({ devices: n.shape.devices }).required(), Te = e.object({ os: n.shape.os }).required(), be = e.object({ ips: n.shape.ips }).required(), Oe = e.object({ keywords: n.shape.keywords }).required(), Ie = e.object({ categories: n.shape.categories }).required(), je = e.object({ contentTypes: n.shape.contentTypes }).required(), we = l.unwrap(), Le = e.xor([
  Se,
  he,
  de,
  le,
  ye,
  ge,
  De,
  Te,
  be,
  Oe,
  Ie,
  je,
  we,
  h
]).readonly();
export {
  K as BrowsersInputRuleTypeSchema,
  N as BrowsersOutputRuleTypeSchema,
  Q as CPA_AUTO_RULES_SPOT_TOKEN_MAX_LENGTH,
  M as CategoriesInputRuleTypeSchema,
  W as CategoriesOutputRuleTypeSchema,
  X as ContentTypeInputRuleTypeSchema,
  F as ContentTypeOutputRuleTypeSchema,
  ve as CpaAutoRulesExclusionsSchema,
  V as CpaAutoRulesSpotTokenSchema,
  Y as CpaAutoRulesSpotsRuleTypeSchema,
  P as DevicesInputRuleTypeSchema,
  U as DevicesOutputRuleTypeSchema,
  Z as DimensionTypeSchema,
  J as DimensionsInputSchema,
  S as DimensionsOutputSchema,
  p as DomainsRuleTypeSchema,
  A as GeoInputRuleTypeSchema,
  B as GeoOutputRuleTypeSchema,
  m as IpsRuleTypeSchema,
  r as KeywordsRuleTypeSchema,
  E as LanguagesInputRuleTypeSchema,
  _ as LanguagesOutputRuleTypeSchema,
  H as OSTypesInputRuleTypeSchema,
  z as OSTypesOutputRuleTypeSchema,
  h as OtherDimensionsSchema,
  x as RuleTypeEnumSchema,
  se as SingleBrowserDimensionInputSchema,
  ge as SingleBrowserDimensionOutputSchema,
  me as SingleCategoryDimensionInputSchema,
  Ie as SingleCategoryDimensionOutputSchema,
  je as SingleContentTypeDimensionOutputSchema,
  ue as SingleContentTypeInputSchema,
  ie as SingleDeviceDimensionInputSchema,
  De as SingleDeviceDimensionOutputSchema,
  ke as SingleDimensionInputSchema,
  Le as SingleDimensionOutputSchema,
  ee as SingleDomainDimensionInputSchema,
  he as SingleDomainDimensionOutputSchema,
  te as SingleGeoDimensionInputSchema,
  le as SingleGeoDimensionOutputSchema,
  ce as SingleIpDimensionInputSchema,
  be as SingleIpDimensionOutputSchema,
  pe as SingleKeywordDimensionInputSchema,
  Oe as SingleKeywordDimensionOutputSchema,
  ne as SingleLanguageDimensionInputSchema,
  ye as SingleLanguageDimensionOutputSchema,
  ae as SingleOsDimensionInputSchema,
  Te as SingleOsDimensionOutputSchema,
  $ as SingleScheduledDimensionInputSchema,
  Se as SingleScheduledDimensionOutputSchema,
  oe as SingleSpotDimensionInputSchema,
  de as SingleSpotDimensionOutputSchema,
  l as SingleStartStopDimensionInputSchema,
  we as SingleStartStopDimensionOutputSchema,
  u as SpotsRuleTypeSchema,
  fe as SubDimensionTypeSchema,
  o as buildRuleTypeSchema
};
//# sourceMappingURL=schemas.js.map
